<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑' : '新增'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="部门" v-if="form.id > 0">
                        {{this.$root.getCustomerName(form.code)}}
                    </el-form-item>
                    <el-form-item label="部门" prop="code" :error="errors.code" v-else-if="$root.isAdmin">
                        <RemoteSelect v-model="form.code" :options="$root.customers"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="业务名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <template v-if="form.id > 0">
                        <el-form-item label="业务账号" prop="account" :error="errors.account">
                            <el-input v-model="form.account" style="width: 200px" :disabled="true"></el-input>
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item label="业务账号" prop="account" :error="errors.account">
                            <el-input v-model="form.account" style="width: 200px"></el-input>
                        </el-form-item>
                        <el-form-item label="业务密码" prop="pwd" :error="errors.pwd">
                            <el-input v-model="form.pwd" style="width: 200px"></el-input>
                        </el-form-item>
                        <el-form-item label="API密码" prop="apiPwd" :error="errors.apiPwd">
                            <el-input v-model="form.apiPwd" style="width: 200px"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item label="签名" prop="sign" :error="errors.sign">
                        <el-input v-model="form.sign" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="国际签名" prop="intlSign" :error="errors.intlSign">
                        <el-input v-model="form.intlSign" style="width: 200px"></el-input>
                    </el-form-item>
<!--                    <el-form-item label="收费方式" prop="costType.value" :error="errors.costType">-->
<!--                        <RemoteSelect v-model="form.costType.value" :url="'/dict/list/cost/type'"></RemoteSelect>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="结算方式" prop="settleType.value" :error="errors.settleType">-->
<!--                        <RemoteSelect v-model="form.settleType.value" :url="'/dict/list/settle/type'"></RemoteSelect>-->
<!--                    </el-form-item>-->
                    <el-form-item label="余额" prop="balance" :error="errors.balance">
                        <el-input-number v-model="form.balance"></el-input-number>
                    </el-form-item>
                    <el-form-item label="IP白名单" prop="ipList">
                        <el-input v-model="form.ipList"></el-input>
                        <p class="help-text">多个地址以“,”分隔</p>
                    </el-form-item>
                  <el-form-item label="开启报告拉取" prop="pullEnabled">
                    <el-checkbox v-model="form.pullEnabled"></el-checkbox>
                  </el-form-item>
                  <el-form-item label="开启自动退订" prop="unsubscribeEnabled">
                    <el-checkbox v-model="form.unsubscribeEnabled"></el-checkbox>
                  </el-form-item>
                    <el-form-item label="上行通知地址" prop="upCallbackUrl">
                        <el-input v-model="form.upCallbackUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="状态回调地址" prop="sendCallbackUrl">
                        <el-input v-model="form.sendCallbackUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="审核回调地址" prop="verifyCallbackUrl">
                        <el-input v-model="form.verifyCallbackUrl"></el-input>
                    </el-form-item>
<!--                    <el-form-item label="模板标题前缀" prop="templatePrefix">-->
<!--                        <el-input v-model="form.templatePrefix"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="扩展号" prop="extNo">-->
<!--                        <el-input v-model="form.extNo"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="计费编号" prop="billingNum">-->
<!--                        <el-input v-model="form.billingNum"></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="状态" prop="status.value" :error="errors.status">
                        <RemoteSelect v-model="form.status.value" :url="'/dict/list/public/status'"></RemoteSelect>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'

    export default {
        components: {
            RemoteSelect
        },
        data() {
            return {
                form: {
                    id: this.$route.params.id,
                    name: "",
                    account: "",
                    pwd: "",
                  apiPwd: "",
                    sign: "",
                  intlSign: "",
                    costType: {value: 'MONTH'},
                    settleType: {value: 'SUCCESS'},
                    balance: 1,
                    ipList: "",
                  pullEnabled: false,
                  unsubscribeEnabled: false,
                    upCallbackUrl: "",
                    sendCallbackUrl: "",
                    verifyCallbackUrl: "",
                    extNo: "",
                    templatePrefix: "",
                    status: {},
                    code: this.$root.isAdmin ? "" : this.$root.code,
                    billingNum: ""
                },
                rules: {
                    name: [
                        {required: true, message: "请填写业务名称"}
                    ],
                    account: [
                        {required: true, message: "请填写业务账号"},
                        {min: 5, max: 15, message: '账号长度在 5 到 15 个字符'}
                    ],
                    pwd: [
                        {required: true, message: "请填写业务密码"},
                        {min: 6, max: 20, message: '密码长度在 6 到 20 个字符'}
                    ],
                  apiPwd: [
                        {required: true, message: "请填写API密码"},
                        {min: 6, max: 20, message: '密码长度在 6 到 20 个字符'}
                    ],
                    "costType.value": [
                        {required: true, message: "请选择收费方式"}
                    ],
                    "settleType.value": [
                        {required: true, message: "请选择结算方式"}
                    ],
                    "status.value": [
                        {required: true, message: "请选择状态"}
                    ],
                    code: [
                        {required: true, message: "请选择部门"}
                    ],
                },
                errors: {}
            }
        },
      beforeMount() {
        if (this.form.id > 0) {
          this.$axios.get("/business/get/" + this.form.id).then(result => {
            this.$utils.merge(this.form, result);
          })
        } else {
          this.$axios.get("/dict/list/config/global").then(resp => {
            this.form.upCallbackUrl = (resp.find(item => item['value'] == "sxdz")||{})['text']||"";
            this.form.sendCallbackUrl = (resp.find(item => item['value'] == "zthddz")||{})['text']||"";
            this.form.verifyCallbackUrl = (resp.find(item => item['value'] == "shhddz")||{})['text']||"";
            this.form.sign = (resp.find(item => item['value'] == "gnqm")||{})['text']||"";
            this.form.intlSign = (resp.find(item => item['value'] == "gjqm")||{})['text']||"";
          })
        }
      },
        methods: {
            submit() {
                let url = this.form.id > 0 ? "/business/edit" : "/business/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$root.refreshBusiness().then(() => {
                      this.$router.go(-1);
                    });
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
              this.$router.go(-1);
            }
        }
    }
</script>